{
  "cycle.entite.adr_reviews": "Tours de revue des ADR",
  "cycle.entite.architecture_lignes_de_base": "Lignes de base de l’architecture",
  "journalAudit.action.adr.cancelled": "ADR annulée",
  "journalAudit.action.adr.superseded": "ADR remplacée",
  "journalAudit.action.architecture.ligne_de_base.figee": "Ligne de base de l’architecture figée",
  "journalAudit.action.technology_change.rework_verified": "Reprise du changement technologique validée"
}
